import { CardProps } from "antd";
import { StatementTitlesTableProvider } from "../../../context/StatementTitlesTableContext";
import { AccountingStatementDescription } from "../accountingStatementsTable/AccountingStatementsTable";
import StatementTitlesTable from "./StatementTitlesTable";
import React from "react";
import { AccountingStatement } from "../../../types/reconciliation";
import { NavigationCard, NavigationCardProps } from "../NavigationCard";

export const TitlesTableCard = ({ relatedAccountingStatement, cardProps, navigationCardProps }: {
  relatedAccountingStatement: AccountingStatement,
  cardProps?: CardProps
  navigationCardProps: NavigationCardProps
}) => {
  return (
    <NavigationCard
      {...navigationCardProps}
      cardProps={cardProps}
    >
      <StatementTitlesTableProvider key={relatedAccountingStatement.uuid}>
        <AccountingStatementDescription accountingStatement={relatedAccountingStatement} />
        <StatementTitlesTable
          showReconciliationColumns={false}
          useStatementsTitlesGroup={false}
          defaultFilters={{ statement_uuid: relatedAccountingStatement.uuid }}
          rowsSelectable={false}
          showConfirmedTitlesColumn={true}
        />
      </StatementTitlesTableProvider>
    </NavigationCard>);
};